export class ClosedDay {
    title!: string;
    fromDate!: string;
    toDate!: string;
}